import { render } from "./PenjadwalanView.vue?vue&type=template&id=57fdb0d0"
import script from "./PenjadwalanView.vue?vue&type=script&lang=js"
export * from "./PenjadwalanView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__